import { gql } from '@apollo/client'

export const CREATE_CAR = gql`
  mutation createCar($input: CreateCarInput!) {
    data: createCar(input: $input) {
      id
    }
  }
`
